import { SwitchAppButton } from "../../components";
import { ActivationRequiredWarning } from "../../components";
import { GrayBackground } from "../../components";
import {
  HookFormSelect,
  SubmitButton,
  TextArea,
  TextInput,
} from "../../hook-form";
import { countries } from "../../constants";
import { industries } from "../../constants";
import info_blue from "../../assets/icons/info_blue.svg";
import {
  IBusinessDetailsSettings,
  IBusinessType,
  IHookForm,
  IRevenueBracket,
} from "../../interfaces-and-types";

export const View = ({
  dataModificationDisabled,

  isLoadingRevenueBrackets,
  revenueBrackets,
  isLoadingBusinessTypes,
  businessTypes,
  registered_countryFormValue,

  goBack,
  isDirty,
  handleSubmit,
  errors,
  register,
}: IHookForm<IBusinessDetailsSettings> & {
  dataModificationDisabled: boolean; // user not allowed to change after verification

  isLoadingRevenueBrackets: boolean;
  revenueBrackets: IRevenueBracket[];
  isLoadingBusinessTypes: boolean;
  businessTypes: IBusinessType[];
  registered_countryFormValue: string;

  goBack: () => void;
  isDirty: boolean;
}) => {
  return (
    <form onSubmit={handleSubmit}>
      <ActivationRequiredWarning
        title="Please you need to activate your profile"
        subtitle="0ur guide will help you complete your Business profile and you’ll start receiving payments. Click this banner to complete your set-up"
        urlTarget="/onboarding"
      />

      <div className="container--business-details">
        <div className="top-into--business-details">
          <div>
            <img src={info_blue} alt="info" />
          </div>
          <span className="text-danger">
            You cannot change your business details, contact us if you need to
            change any details.
          </span>
        </div>
        <GrayBackground>
          <div className="flex-container row business-gap">
            <div className="flex-container flex-box col row-container-business-details">
              <HookFormSelect
                name="registered_country"
                label="Country Of Registration"
                infoIconText="Country where the business is registered. The country of operation may be different from country of registration."
                containerClassName="settings-select"
                selectItems={[]}
                selectGroupedItems={countries}
                register={register}
                errors={errors}
                disabled={dataModificationDisabled}
              />

              <HookFormSelect
                name="registered_business_type_id"
                label="Business Type"
                infoIconText="The ownership structure of the business."
                showSkeleton={isLoadingBusinessTypes}
                containerClassName="settings-select"
                selectItems={
                  businessTypes.map((businessType) => ({
                    text: businessType.business_type_name,
                    value: businessType.id,
                  })) || []
                }
                register={register}
                errors={errors}
                disabled={dataModificationDisabled}
              />

              <TextInput
                name="registration_number"
                label={`Business Registration Number ${
                  registered_countryFormValue === "NG" ? "" : " (Optional)"
                }`}
                infoIconText="This is the RC or RCN in the cerificate of incorporation. It usually consists of letters and numbers"
                containerClassName="settings-input"
                type="text"
                register={register}
                errors={errors}
                disabled={dataModificationDisabled}
              />
              <TextInput
                name="business_address_line1"
                label="Business Address Line 1"
                containerClassName="settings-input"
                type="text"
                register={register}
                errors={errors}
                disabled={dataModificationDisabled}
              />
              <TextInput
                name="business_address_line2"
                label="Business Address Line 2 (Optional)"
                containerClassName="settings-input"
                type="text"
                register={register}
                errors={errors}
                disabled={dataModificationDisabled}
              />
            </div>

            <div className="flex-container flex-box col row-container-business-details">
              <TextInput
                name="registered_business_name"
                label="Registered Business Name"
                infoIconText="The name of the business as it appears in the registration certificate"
                containerClassName="settings-input"
                type="text"
                register={register}
                errors={errors}
                disabled={dataModificationDisabled}
              />
              <HookFormSelect
                name="industry"
                label="Industry"
                infoIconText="The industry the business is involved in. Select the most fitting if you fall in more than one category."
                containerClassName="settings-select"
                selectItems={industries.map((ind) => ({
                  text: ind.key,
                  value: ind.value,
                }))}
                register={register}
                errors={errors}
                disabled={dataModificationDisabled}
              />
              <TextInput
                name="business_email_address"
                label="Business Email Address"
                infoIconText="Email address that can be used to reach the business directly."
                containerClassName="settings-input"
                type="text"
                register={register}
                errors={errors}
                disabled={dataModificationDisabled}
              />
              <TextInput
                name="business_website"
                label="Business Website (Optional)"
                placeholder="http://"
                containerClassName="settings-input"
                type="text"
                register={register}
                errors={errors}
                disabled={dataModificationDisabled}
              />
              <TextInput
                name="business_terms_and_conditions_url"
                label="Terms & Conditions Url (Optional)"
                placeholder="http://"
                containerClassName="settings-input"
                type="text"
                register={register}
                errors={errors}
                disabled={dataModificationDisabled}
              />
              <TextInput
                name="business_privacy_url"
                label="Privacy Url (Optional)"
                placeholder="http://"
                containerClassName="settings-input"
                type="text"
                register={register}
                errors={errors}
                disabled={dataModificationDisabled}
              />
            </div>

            <div className="flex-container flex-box col row-container-business-details">
              <TextArea
                name="business_description"
                label="Business Description (Optional)"
                infoIconText="A small description that your customers will see about you."
                containerClassName="settings-input"
                register={register}
                errors={errors}
                disabled={dataModificationDisabled}
              />

              <HookFormSelect
                name="estimated_monthly_sale_id"
                label="Estimated Monthly Sales (NGN)"
                infoIconText="This will help us better recommend services to you and inform you if you need to upgrade to different tiers to avoid service disruption."
                showSkeleton={isLoadingRevenueBrackets}
                containerClassName="settings-select"
                selectItems={
                  revenueBrackets.map((revenueBracket) => ({
                    text: revenueBracket.revenue_bracket_name,
                    value: revenueBracket.id,
                  })) || []
                }
                register={register}
                errors={errors}
                disabled={dataModificationDisabled}
              />
            </div>
          </div>

          <div
            style={{ marginTop: "50px" }}
            className="flex-container justify-content--end align-items--end"
          >
            <div className="button-group">
              <SwitchAppButton size="sm" kind="secondary" onClick={goBack}>
                Cancel
              </SwitchAppButton>

              <SubmitButton
                title={
                  dataModificationDisabled
                    ? "Contact us to change the details about your business."
                    : null
                }
                size="sm"
                disabled={dataModificationDisabled /*|| !isDirty*/}
                showChildrenWithLoadingIcon
              >
                Save
              </SubmitButton>
            </div>
          </div>
        </GrayBackground>
      </div>
    </form>
  );
};
